<script>
    import StatusBadge from '../../common/StatusBadge.svelte';
    import {sgettext} from '../../../i18n.js';

    export let versions = [];
    export let expired = false;
    export let status = null;
    export let data;

    $: display = showStatus(versions);

    function showStatus(versions){
        let display = '';
        if (expired) {
            display = sgettext('$$ARCHIVED$$')
        } else {
            // Element is considered to be in the draft state iff there is only one available version and the version
            // itself is in a draft state.
            // if (versions.length === 1 && versions[0].status.toLowerCase() === 'draft') {
            //     display = 'Draft';
            // }
            // else if (status && status !== 'Current') {
            //     // Since Current is the assumed default, we don't actually want to display it so as to avoid clutter
            //     display = status;
            // }

            if (status && status.toLowerCase() !== 'current') {
                display = sgettext(status);
            }
        }
        return display;
    }
</script>

{#if display}
    <StatusBadge status={display} />
{/if}
